<template>
  <v-card style="height: 100%" :class="{ 'grey lighten-1': disabled }">
    <v-card-text>
      <p class="ma-0">
        <slot></slot>
      </p>
      <h3 class="headline text-xs-right">
        <div v-if="disabled">-</div>
        <template v-else>
          <!-- <pulse-loader :color="$vuetify.theme.primary" :size="'5px'" v-if="loading"></pulse-loader> -->
          <v-progress-circular
            indeterminate
            color="primary"
            size="25"
            v-if="loading"
          ></v-progress-circular>
          <template v-else-if="value === false"> N/A </template>
          <tween-num
            v-else
            :value="parseInt(value)"
            :initial="0"
            :formatter="numberFormat"
          ></tween-num>
        </template>
      </h3>
    </v-card-text>
  </v-card>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import TweenNum from 'vue-tween-number'
import numeral from 'numeral'

export default {
  props: ['value', 'loading', 'disabled'],
  data: function () {
    return {}
  },
  components: {
    TweenNum,
    PulseLoader
  },
  methods: {
    numberFormat: function (val) {
      return numeral(val).format('0,0')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/StatCard.vue